do (window=window, document=document, $=jQuery) ->
  
  sn = $.Quantize = {}

  sn.support = {}

  class sn.Quantize
    defaults:
      kerningObj: 
        "!": [-0.05, -0.03]
        "\"": [-0.06, -0.05]
        "#": [-0.02, 0]
        "%": [0, -0.03]
        "&": [-0.02, 0]
        "'": [-0.06, -0.05]
        "(": [-0.03, 0]
        ")": [0, -0.03]
        "*": [-0.02, -0.02]
        "+": [-0.03, -0.03]
        ",": [-0.05, -0.03]
        "-": [-0.03, -0.03]
        ".": [-0.05, -0.03]
        "0": [0, -0.02]
        "1": [-0.03, -0.02]
        "2": [-0.02, -0.02]
        "3": [-0.02, 0]
        "4": [-0.02, 0]
        "5": [-0.02, -0.02]
        "6": [-0.02, -0.02]
        "7": [-0.03, -0.02]
        "8": [-0.02, 0]
        "9": [-0.02, -0.02]
        ":": [-0.05, -0.03]
        ";": [-0.05, -0.03]
        "<": [-0.03, -0.03]
        "=": [-0.03, -0.02]
        ">": [-0.03, -0.03]
        "?": [-0.02, -0.02]
        "@": [-0.02, -0.02]
        "B": [0, -0.03]
        "C": [-0.02, -0.02]
        "D": [-0.05, -0.02]
        "E": [-0.05, 0]
        "F": [-0.05, 0]
        "G": [-0.02, -0.03]
        "H": [-0.05, -0.03]
        "I": [-0.05, -0.03]
        "J": [0, -0.03]
        "K": [-0.05, 0]
        "M": [-0.05, -0.05]
        "N": [-0.05, -0.03]
        "O": [-0.02, -0.02]
        "P": [-0.05, -0.02]
        "Q": [-0.03, -0.02]
        "R": [-0.05, -0.02]
        "S": [-0.02, 0]
        "U": [-0.05, -0.03]
        "[": [-0.05, -0.03]
        "]": [-0.05, -0.03]
        "^": [-0.05, -0.03]
        "`": [0, -0.02]
        "a": [-0.02, -0.02]
        "b": [-0.03, -0.02]
        "c": [-0.02, -0.01]
        "d": [-0.02, -0.03]
        "e": [-0.02, 0]
        "g": [-0.02, -0.03]
        "h": [-0.03, -0.03]
        "i": [-0.03, -0.04]
        "j": [0, -0.03]
        "k": [-0.02, 0]
        "l": [0, -0.03]
        "m": [-0.03, -0.03]
        "n": [-0.02, -0.05]
        "o": [-0.03, -0.02]
        "p": [-0.03, 0]
        "q": [-0.02, -0.03]
        "r": [-0.03, -0.02]
        "s": [-0.06, 0]
        "u": [-0.03, -0.03]
        "{": [0, -0.06]
        "|": [0, -0.06]
        "}": [0, -0.06]
        "~": [0, -0.08]
        "　": [-0.15, -0.15]
        "、": [-0.03, -0.48]
        "。": [-0.03, -0.5]
        "〈": [-0.45, -0.02]
        "〉": [-0.02, -0.45]
        "《": [-0.41, -0.02]
        "》": [-0.02, -0.41]
        "「": [-0.59, -0.02]
        "」": [-0.02, -0.59]
        "『": [-0.47, -0.02]
        "』": [-0.02, -0.47]
        "【": [-0.41, -0.02]
        "】": [-0.02, -0.41]
        "〒": [-0.09, -0.09]
        "〓": [-0.09, -0.09]
        "〔": [-0.51, -0.02]
        "〕": [-0.02, -0.51]
        "〘": [-0.44, -0.03]
        "〙": [-0.03, -0.42]
        "〜": [-0.03, -0.03]
        "〝": [-0.38, -0.02]
        "〟": [-0.02, -0.38]
        "ぁ": [-0.15, -0.12]
        "あ": [-0.08, -0.05]
        "ぃ": [-0.14, -0.12]
        "い": [-0.06, -0.05]
        "ぅ": [-0.21, -0.2]
        "う": [-0.15, -0.16]
        "ぇ": [-0.15, -0.15]
        "え": [-0.09, -0.09]
        "ぉ": [-0.12, -0.11]
        "お": [-0.05, -0.03]
        "か": [-0.06, -0.03]
        "が": [-0.06, -0.02]
        "き": [-0.14, -0.12]
        "ぎ": [-0.14, -0.12]
        "く": [-0.2, -0.21]
        "ぐ": [-0.2, -0.08]
        "け": [-0.11, -0.05]
        "げ": [-0.11, 0]
        "こ": [-0.15, -0.12]
        "ご": [-0.15, -0.02]
        "さ": [-0.13, -0.14]
        "ざ": [-0.13, -0.03]
        "し": [-0.15, -0.06]
        "じ": [-0.15, -0.06]
        "す": [-0.03, -0.03]
        "ず": [-0.03, 0]
        "そ": [-0.09, -0.08]
        "ぞ": [-0.09, -0.03]
        "た": [-0.09, -0.06]
        "だ": [-0.09, -0.02]
        "ち": [-0.11, -0.08]
        "ぢ": [-0.11, -0.06]
        "っ": [-0.11, -0.12]
        "つ": [-0.03, -0.05]
        "づ": [-0.03, -0.04]
        "て": [-0.08, -0.08]
        "で": [-0.08, -0.02]
        "と": [-0.16, -0.15]
        "ど": [-0.16, -0.05]
        "な": [-0.13, -0.06]
        "に": [-0.11, -0.06]
        "ぬ": [-0.06, -0.03]
        "ね": [-0.05, -0.03]
        "の": [-0.06, -0.06]
        "は": [-0.09, -0.05]
        "ば": [-0.09, 0]
        "ぱ": [-0.09, 0]
        "ひ": [-0.12, -0.03]
        "び": [-0.12, 0]
        "ぴ": [-0.12, 0]
        "ふ": [-0.02, -0.02]
        "ぶ": [-0.02, -0.02]
        "ぷ": [-0.02, -0.02]
        "へ": [-0.03, 0]
        "べ": [-0.03, 0]
        "ぺ": [-0.03, 0]
        "ほ": [-0.09, -0.05]
        "ぼ": [-0.09, 0]
        "ぽ": [-0.09, 0]
        "ま": [-0.11, -0.12]
        "み": [-0.03, -0.02]
        "む": [-0.08, -0.05]
        "め": [-0.08, -0.05]
        "も": [-0.11, -0.14]
        "ゃ": [-0.12, -0.11]
        "や": [-0.03, -0.03]
        "ゅ": [-0.12, -0.12]
        "ゆ": [-0.05, -0.03]
        "ょ": [-0.18, -0.18]
        "よ": [-0.14, -0.12]
        "ら": [-0.15, -0.09]
        "り": [-0.2, -0.18]
        "る": [-0.11, -0.11]
        "れ": [-0.03, 0]
        "ろ": [-0.1, -0.08]
        "ゎ": [-0.12, -0.12]
        "わ": [-0.03, -0.03]
        "ゐ": [-0.06, -0.08]
        "ゑ": [-0.03, -0.03]
        "を": [-0.11, -0.06]
        "ん": [-0.06, -0.05]
        "ゔ": [-0.12, -0.02]
        "゛": [0, -0.5]
        "゜": [-0.02, -0.54]
        "ゝ": [-0.22, -0.2]
        "ゞ": [-0.22, -0.11]
        "ァ": [-0.15, -0.12]
        "ア": [-0.09, -0.06]
        "ィ": [-0.2, -0.21]
        "イ": [-0.1, -0.15]
        "ゥ": [-0.15, -0.16]
        "ウ": [-0.09, -0.11]
        "ェ": [-0.18, -0.12]
        "エ": [-0.03, -0.05]
        "ォ": [-0.12, -0.15]
        "オ": [-0.05, -0.08]
        "カ": [-0.08, -0.05]
        "ガ": [-0.08, 0]
        "キ": [-0.09, -0.08]
        "ギ": [-0.09, -0.02]
        "ク": [-0.05, -0.11]
        "グ": [-0.03, 0]
        "ケ": [-0.05, -0.08]
        "ゲ": [-0.05, -0.03]
        "コ": [-0.12, -0.11]
        "ゴ": [-0.12, 0]
        "サ": [-0.02, -0.02]
        "ザ": [-0.02, 0]
        "シ": [-0.08, -0.02]
        "ジ": [-0.08, 0]
        "ス": [-0.08, -0.08]
        "ズ": [-0.08, -0.06]
        "セ": [-0.05, -0.06]
        "ゼ": [-0.05, 0]
        "ソ": [-0.12, -0.11]
        "ゾ": [-0.12, 0]
        "タ": [-0.02, -0.11]
        "ダ": [-0.02, 0]
        "チ": [-0.06, -0.06]
        "ヂ": [-0.06, 0]
        "ッ": [-0.16, -0.15]
        "ツ": [-0.11, -0.09]
        "ヅ": [-0.11, 0]
        "テ": [-0.08, -0.06]
        "デ": [-0.08, 0]
        "ト": [-0.22, -0.12]
        "ド": [-0.22, -0.08]
        "ナ": [-0.06, -0.05]
        "ニ": [-0.05, -0.06]
        "ヌ": [-0.08, -0.12]
        "ネ": [-0.03, -0.09]
        "ノ": [-0.08, -0.14]
        "ハ": [-0.02, -0.06]
        "バ": [-0.02, -0.06]
        "パ": [-0.02, -0.06]
        "ヒ": [-0.12, -0.12]
        "ビ": [-0.12, -0.03]
        "ピ": [-0.12, -0.06]
        "フ": [-0.12, -0.11]
        "ブ": [-0.12, 0]
        "プ": [-0.12, 0]
        "ヘ": [-0.06, -0.02]
        "ベ": [-0.06, -0.02]
        "ペ": [-0.06, -0.02]
        "ホ": [-0.08, -0.08]
        "ボ": [-0.08, -0.03]
        "ポ": [-0.08, -0.08]
        "マ": [-0.06, -0.05]
        "ミ": [-0.15, -0.15]
        "ム": [-0.08, -0.09]
        "メ": [-0.05, -0.15]
        "モ": [-0.06, -0.06]
        "ャ": [-0.14, -0.12]
        "ヤ": [-0.06, -0.05]
        "ュ": [-0.12, -0.12]
        "ユ": [-0.05, -0.05]
        "ョ": [-0.18, -0.15]
        "ヨ": [-0.12, -0.09]
        "ラ": [-0.11, -0.11]
        "リ": [-0.16, -0.18]
        "ル": [-0.02, 0]
        "レ": [-0.14, -0.05]
        "ロ": [-0.09, -0.13]
        "ヮ": [-0.16, -0.15]
        "ワ": [-0.11, -0.09]
        "ヰ": [-0.06, -0.06]
        "ヱ": [-0.03, -0.03]
        "ヲ": [-0.12, -0.09]
        "ン": [-0.11, -0.08]
        "ヴ": [-0.09, 0]
        "ヵ": [-0.11, -0.16]
        "ヶ": [-0.12, -0.15]
        "・": [-0.27, -0.27]
        "ー": [-0.08, -0.02]
        "ヽ": [-0.16, -0.18]
        "ヾ": [-0.16, -0.12]
        "！": [-0.28, -0.28]
        "＃": [-0.11, -0.11]
        "＄": [-0.16, -0.16]
        "％": [-0.08, -0.08]
        "＆": [-0.09, -0.03]
        "（": [-0.47, -0.02]
        "）": [-0.02, -0.47]
        "＊": [-0.2, -0.2]
        "＋": [-0.12, -0.12]
        "，": [-0.03, -0.53]
        "－": [-0.12, -0.12]
        "．": [-0.03, -0.53]
        "／": [-0.03, -0.03]
        "：": [-0.28, -0.28]
        "；": [-0.27, -0.28]
        "＜": [-0.12, -0.14]
        "＝": [-0.12, -0.12]
        "＞": [-0.14, -0.12]
        "？": [-0.16, -0.18]
        "＠": [-0.06, -0.06]
        "［": [-0.47, -0.03]
        "＼": [-0.02, -0.03]
        "］": [-0.03, -0.47]
        "＾": [-0.21, -0.21]
        "｀": [-0.21, -0.3]
        "｛": [-0.44, -0.02]
        "｜": [-0.35, -0.35]
        "｝": [-0.02, -0.44]
        "～": [-0.05, -0.06]
        "ｦ": [-0.03, -0.02]
        "ｧ": [-0.05, -0.02]
        "ｨ": [-0.03, -0.05]
        "ｩ": [-0.06, -0.03]
        "ｪ": [-0.05, -0.05]
        "ｫ": [-0.03, -0.03]
        "ｬ": [-0.02, -0.02]
        "ｭ": [-0.05, -0.05]
        "ｮ": [-0.06, -0.06]
        "ｯ": [-0.03, -0.03]
        "ｰ": [-0.03, -0.03]
        "ｱ": [-0.02, 0]
        "ｲ": [-0.02, -0.02]
        "ｳ": [-0.05, -0.02]
        "ｴ": [-0.02, -0.02]
        "ｵ": [-0.02, -0.02]
        "ｶ": [0, -0.03]
        "ｷ": [-0.02, -0.02]
        "ｸ": [-0.02, -0.02]
        "ｹ": [-0.02, -0.02]
        "ｺ": [-0.05, -0.05]
        "ｻ": [-0.02, -0.02]
        "ｼ": [-0.02, -0.02]
        "ｽ": [-0.02, -0.02]
        "ｿ": [-0.02, 0]
        "ﾀ": [-0.02, -0.02]
        "ﾁ": [-0.02, -0.02]
        "ﾂ": [-0.02, 0]
        "ﾃ": [-0.02, -0.02]
        "ﾄ": [-0.09, -0.02]
        "ﾅ": [-0.02, -0.02]
        "ﾆ": [-0.02, -0.02]
        "ﾇ": [-0.02, -0.02]
        "ﾈ": [-0.02, 0]
        "ﾉ": [-0.02, -0.02]
        "ﾊ": [-0.02, -0.02]
        "ﾋ": [-0.05, -0.03]
        "ﾌ": [-0.03, -0.02]
        "ﾎ": [-0.02, -0.02]
        "ﾏ": [-0.03, 0]
        "ﾐ": [-0.03, -0.02]
        "ﾑ": [-0.02, 0]
        "ﾒ": [0, -0.02]
        "ﾓ": [-0.02, -0.03]
        "ﾔ": [-0.02, 0]
        "ﾕ": [-0.02, -0.02]
        "ﾖ": [-0.03, -0.05]
        "ﾗ": [-0.05, -0.03]
        "ﾘ": [-0.06, -0.05]
        "ﾚ": [-0.05, -0.02]
        "ﾛ": [-0.03, -0.03]
        "ﾜ": [-0.05, -0.02]
        "ﾝ": [-0.02, -0.02]
        "ﾞ": [0, -0.2]
        "ﾟ": [-0.02, -0.22]
      kerningPairObj:
        "TW": -0.03
        "Lv": -0.07
        "Pe": -0.04
        "Pa": -0.03
        "Kw": -0.04
        "TJ": -0.07
        "Ku": -0.04
        "Ky": -0.04
        "Ko": -0.04
        "SY": -0.04
        "SX": -0.03
        "TA": -0.12
        "Kg": -0.04
        "GW": -0.03
        "Ke": -0.04
        "Ka": -0.04
        "SV": -0.04
        "SW": -0.03
        "Ay": -0.04
        "Aw": -0.04
        "Ly": -0.07
        "SA": -0.04
        "Av": -0.04
        "Au": -0.04
        "RY": -0.04
        "RV": -0.04
        "RX": -0.03
        "QY": -0.04
        "RW": -0.03
        "QX": -0.03
        "GA": -0.04
        "At": -0.04
        "As": -0.04
        "GV": -0.04
        "Aq": -0.04
        "QW": -0.03
        "QV": -0.04
        "Aj": -0.04
        "PY": -0.04
        "QA": -0.04
        "Ag": -0.04
        "Af": -0.04
        "PX": -0.03
        "PW": -0.03
        "PV": -0.04
        "Ae": -0.04
        "PJ": -0.07
        "Ad": -0.04
        "Ac": -0.04
        "Aa": -0.04
        "XS": -0.04
        "OY": -0.04
        "PA": -0.12
        "XQ": -0.04
        "OX": -0.03
        "XO": -0.04
        "OV": -0.04
        "OW": -0.03
        "XJ": -0.04
        "XG": -0.04
        "XC": -0.04
        "OA": -0.04
        "YS": -0.04
        "LV": -0.12
        "LY": -0.12
        "LW": -0.09
        "YQ": -0.04
        "YO": -0.04
        "LT": -0.12
        "LQ": -0.04
        "YJ": -0.07
        "Ao": -0.04
        "LO": -0.04
        "TV": -0.04
        "is": -0.04
        "Yu": -0.06
        "YG": -0.04
        "Ye": -0.09
        "Ya": -0.09
        "YA": -0.12
        "YC": -0.04
        "WS": -0.04
        "Yo": -0.09
        "WO": -0.04
        "WQ": -0.04
        "Xe": -0.06
        "Xa": -0.06
        "Wy": -0.04
        "Wr": -0.04
        "Wo": -0.07
        "WJ": -0.07
        "WG": -0.04
        "LG": -0.04
        "WC": -0.04
        "LC": -0.04
        "We": -0.07
        "KS": -0.03
        "Wa": -0.07
        "VS": -0.04
        "WA": -0.09
        "Vz": -0.04
        "Vy": -0.06
        "KQ": -0.04
        "FJ": -0.07
        "Vw": -0.04
        "VO": -0.04
        "KO": -0.04
        "VQ": -0.04
        "Vu": -0.06
        "VG": -0.04
        "VJ": -0.07
        "FA": -0.12
        "KG": -0.04
        "DV": -0.04
        "DW": -0.03
        "Vr": -0.06
        "Vo": -0.09
        "DY": -0.04
        "CW": -0.03
        "VC": -0.04
        "VA": -0.12
        "CY": -0.04
        "DA": -0.04
        "CV": -0.04
        "Ve": -0.09
        "TY": -0.04
        "UA": -0.04
        "CA": -0.04
        "BY": -0.04
        "BW": -0.03
        "KC": -0.04
        "BV": -0.04
        "BA": -0.03
        "JA": -0.03
        "GY": -0.04
        "AW": -0.09
        "AY": -0.12
        "Va": -0.09
        "AV": -0.12
        "Tz": -0.12
        "Ty": -0.12
        "AQ": -0.04
        "Tw": -0.12
        "AT": -0.12
        "AO": -0.04
        "AG": -0.04
        "Tr": -0.07
        "To": -0.12
        "Te": -0.12
        "Ta": -0.12
        "TX": -0.03
        "Sy": -0.06
        "Sx": -0.03
        "Tu": -0.12
        "AC": -0.04
        "Sw": -0.04
        "Po": -0.04
      widthOfHalfPitch:
        " ": 0.3036
        " ": 0.3036
        "!": 0.3572
        "\"": 0.5
        "#": 0.625
        "$": 0.625
        "%": 1
        "&": 0.7322
        "'": 0.3036
        "(": 0.3572
        ")": 0.3572
        "*": 0.5
        "+": 0.625
        ",": 0.3036
        "-": 0.4286
        ".": 0.3036
        "/": 0.3572
        "0": 0.625
        "1": 0.625
        "2": 0.625
        "3": 0.625
        "4": 0.625
        "5": 0.625
        "6": 0.625
        "7": 0.625
        "8": 0.625
        "9": 0.625
        ":": 0.3572
        ";": 0.3572
        "<": 0.625
        "=": 0.625
        ">": 0.625
        "?": 0.625
        "@": 0.8036
        "A": 0.6786
        "B": 0.6608
        "C": 0.6786
        "D": 0.7143
        "E": 0.6072
        "F": 0.5715
        "G": 0.7143
        "H": 0.6965
        "I": 0.2679
        "J": 0.4643
        "K": 0.625
        "L": 0.5179
        "M": 0.8572
        "N": 0.6965
        "O": 0.7322
        "P": 0.6429
        "Q": 0.7322
        "R": 0.6429
        "S": 0.625
        "T": 0.5358
        "U": 0.6965
        "V": 0.6429
        "W": 0.9108
        "X": 0.625
        "Y": 0.6072
        "Z": 0.6072
        "[": 0.3572
        "\\": 0.3572
        "]": 0.3572
        "^": 0.625
        "_": 0.5
        "`": 0.3572
        "a": 0.5179
        "b": 0.5536
        "c": 0.5179
        "d": 0.5536
        "e": 0.5358
        "f": 0.2858
        "g": 0.5536
        "h": 0.5536
        "i": 0.25
        "j": 0.25
        "k": 0.5358
        "l": 0.25
        "m": 0.7858
        "n": 0.5536
        "o": 0.5536
        "p": 0.5536
        "q": 0.5536
        "r": 0.375
        "s": 0.4822
        "t": 0.3393
        "u": 0.5358
        "v": 0.5
        "w": 0.7322
        "x": 0.4822
        "y": 0.5179
        "z": 0.4822
        "{": 0.3572
        "|": 0.3036
        "}": 0.3572
        "~": 0.625
        "": 0.3929
        "｡": 0.5
        "｢": 0.5
        "｣": 0.5
        "､": 0.5
        "･": 0.5
        "ｦ": 0.5
        "ｧ": 0.5
        "ｨ": 0.5
        "ｩ": 0.5
        "ｪ": 0.5
        "ｫ": 0.5
        "ｬ": 0.5
        "ｭ": 0.5
        "ｮ": 0.5
        "ｯ": 0.5
        "ｰ": 0.5
        "ｱ": 0.5
        "ｲ": 0.5
        "ｳ": 0.5
        "ｴ": 0.5
        "ｵ": 0.5
        "ｶ": 0.5
        "ｷ": 0.5
        "ｸ": 0.5
        "ｹ": 0.5
        "ｺ": 0.5
        "ｻ": 0.5
        "ｼ": 0.5
        "ｽ": 0.5
        "ｾ": 0.5
        "ｿ": 0.5
        "ﾀ": 0.5
        "ﾁ": 0.5
        "ﾂ": 0.5
        "ﾃ": 0.5
        "ﾄ": 0.5
        "ﾅ": 0.5
        "ﾆ": 0.5
        "ﾇ": 0.5
        "ﾈ": 0.5
        "ﾉ": 0.5
        "ﾊ": 0.5
        "ﾋ": 0.5
        "ﾌ": 0.5
        "ﾍ": 0.5
        "ﾎ": 0.5
        "ﾏ": 0.5
        "ﾐ": 0.5
        "ﾑ": 0.5
        "ﾒ": 0.5
        "ﾓ": 0.5
        "ﾔ": 0.5
        "ﾕ": 0.5
        "ﾖ": 0.5
        "ﾗ": 0.5
        "ﾘ": 0.5
        "ﾙ": 0.5
        "ﾚ": 0.5
        "ﾛ": 0.5
        "ﾜ": 0.5
        "ﾝ": 0.5
        "ﾞ": 0.5
        "ﾟ": 0.5
        "ﾠ": 0.5179
        "": 0.5179
        "": 0.5179
        "": 0.5179
        "": 0.5179
      firstKerningList: "([｛〔〈《「『【〘〖〝‘“｟«"
      beforeException: "〈《「『【〔〘〝（［｛"
      afterException: "〉》」』】〕〙〟）］｝"

    # ------------------------------------------------------------
    constructor: (@$el, options) ->
      if @_getBrowser().browser is "MSIE" and @_getBrowser().version <= 7 
        # IE 7以下はカーニング処理を行わない
        return

      @options = $.extend {}, @defaults, options

    # ------------------------------------------------------------
    setup: ->
      return $.Deferred (defer) =>
        onDone = =>
          defer.resolve()

        offset          = 1
        offset1         = 1
        offset2         = 1
        offsetJP        = 0.5
        offsetEN        = 0
        offsetException = 0.8

        if @options.offset?
          offset = @options.offset

        html = @$el.html().replace(/[\n\r]/g, "")

        # カーニングを調整した後に差し替える
        @$el.html("")

        afterHTML = ""
        tagHash = {}
        regObj = RegExp(/<.+?>/g)
        regArr = []

        while (regArr = regObj.exec(html)) isnt null
          tagHash[regArr.index] = regArr[0]

        isBegining = true;
        l = html.length;
        total = 0;
        maxTotal = 0;
        lineWidth = 0;
        lineKerning = 0;
        skip = 0;

        for i in [0..l]
          if i < skip then continue

          if tagHash[i]
            afterHTML += tagHash[i]
            skip = i + tagHash[i].length
            isBegining = true
            maxTotal = if maxTotal > total then maxTotal else total
            total = 0
            continue

          char = html.charAt(i)
          nextChar = html.charAt(i + 1) or ""

          charWidth = if @options.widthOfHalfPitch[char] isnt undefined then @options.widthOfHalfPitch[char] else 1
          nextCharWidth = if @options.widthOfHalfPitch[nextChar] isnt undefined then @options.widthOfHalfPitch[nextChar] else 1

          charCode = char.charCodeAt(0)
          nextCharCode = nextChar.charCodeAt(0)

          if charCode < 256 or (charCode >= 0xff61 and charCode <= 0xff9f)
            offset1 = offsetEN;
          else
            if @options.afterException.indexOf(charCode) > -1
              offset1 = offsetException
            else
              offset1 = offsetJP

          if nextCharCode < 256 or (nextCharCode >= 0xff61 and nextCharCode <= 0xff9f)
            offset2 = offsetEN
          else
            if @options.beforeException.indexOf(nextCharCode) > -1
              offset2 = offsetException
            else
              offset2 = offsetJP

          k = 0

          if @options.kerningPairObj[char + nextChar]
            k = @options.kerningPairObj[char + nextChar] * (offset1 + offset2) * 0.5
            total += k
          else
            if @options.kerningObj[char] and @options.kerningObj[char][1]
              k += @options.kerningObj[char][1] * offset1
            if @options.kerningObj[nextChar] and @options.kerningObj[nextChar][0]
              k += @options.kerningObj[nextChar][0] * offset2
            total += k

          k += @_getDefaultSpacing(@$el)

          direction = if k >= 0 then 1 else -1

          style = "letter-spacing:" + ((((0.5 + (1000 * Math.abs(k)) ) << 0) / 1000) * direction) + "em;"

          if isBegining
            if @options.kerningObj[char] and @options.kerningObj[char][0]
              if @options.firstKerningList.indexOf(char) isnt -1
                style += "margin-left:" + (@options.kerningObj[char][0] / 2) + "em;"
                total += @options.kerningObj[char][0] / 2
            isBegining = false

          afterHTML += "<span style='" + style + "'>" + char + "</span>"

          if (65 <= charCode && charCode <= 90) or (97 <= charCode && charCode <= 122)
            charWidth *= 1.1
          total += charWidth * 1.042


        maxTotal = if maxTotal > total then maxTotal else total

        @$el.html(afterHTML)

        onDone()
      .promise()

    # ------------------------------------------------------------
    _getDefaultSpacing: ($el) ->
      # CSS で設定されているデフォルトのletter-spacingを返す
      fontSize = $el.css "font-size"
      letterSpacing = $el.css "letter-spacing"
      
      fontSize = (fontSize.replace /px/, '') * 1

      if letterSpacing is "normal"
        letterSpacing = 0
      else
        letterSpacing = (letterSpacing.replace /px/, '') * 1

      return letterSpacing / fontSize

    # ------------------------------------------------------------
    _getBrowser: () ->
      result = {}
      dataBrowser = [
        { string: navigator.userAgent, subString: "Chrome",  identity: "Chrome" }
        { string: navigator.userAgent, subString: "MSIE",    identity: "Explorer" }
        { string: navigator.userAgent, subString: "Firefox", identity: "Firefox" }
        { string: navigator.userAgent, subString: "Safari",  identity: "Safari" }
        { string: navigator.userAgent, subString: "Opera",   identity: "Opera" }
      ]

      for i in [0...dataBrowser.length]
        dataString = dataBrowser[i].string
        versionSearchString = dataBrowser[i].subString

        if dataString.indexOf(dataBrowser[i].subString) isnt -1
          result.browser = dataBrowser[i].identity
          break
        else
          result.browser = "Other"

      index = dataString.indexOf(versionSearchString)
      if index is -1
        result.version = "Unknown"
      else
        result.version = parseFloat(dataString.substring(index + versionSearchString.length + 1))

      return result 


  # ============================================================
  # bridge to plugin
  # ============================================================
  $.fn.quantize = (options) ->
    return $.Deferred (defer) =>
      onDone = =>
        defer.resolve()

      limit = @.size() - 1

      @each (i, el) ->
        $el = $(el)
        instance = new sn.Quantize $el, options
        instance.setup()
        $el.data "quantize", instance

        if i is limit
          onDone()

      onDone()
    .promise()

  $.Quantize = sn.Quantize


/** WEBPACK FOOTER **
 ** ./app_components/jquery.quantize.coffee
 **/